export const WHITE = '#fff';
export const GREY = '#c6c6c6';
export const PRIMARY = '#00b469';
export const PRIMARY_LIGHT = '#8ad9b5';
export const PRIMARY_DARK = '#006E3F';
export const SECONDARY = '#0B65AA';
export const SECONDARY_LIGHT = '#009d9f';
export const SECONDARY_DARK = '#053C67';
export const ERROR = '#E60046';
export const WARNING = '#FF9200';
export const TEXT = '#414140';




// WEBPACK FOOTER //
// ./src/constants/colors.js